import { Card } from './Card';

export function OpenPositions() {
  return (
    <Card>
      <div className="border-ink-800 border-b px-5 py-3.5">
        <div className="flex items-center gap-2.5">
          <span className="relative flex h-2.5 w-2.5">
            <span className="bg-success-500 absolute inline-flex h-full w-full animate-ping rounded-full opacity-75" />
            <span className="bg-success-500 relative inline-flex h-2.5 w-2.5 rounded-full" />
          </span>
          <p className="text-ink-100 text-sm font-semibold">Posições abertas</p>
        </div>
      </div>
      <div className="px-5 py-10 text-center">
        <p className="text-ink-400 text-sm">
          As posições atuais serão atualizadas após a auditoria diária
        </p>
      </div>
    </Card>
  );
}
